// extracted by mini-css-extract-plugin
export default {"colorBrand":"#254a91","colorWhite":"#fff","colorBlueBright":"#81a9f2","ViewIconButton":"ViewIconButton_yCfwJ","Active":"Active_I8CAN","TableViewButton":"TableViewButton_fOETb"};